const FinanceIndex = () => import('@/modules/finances/views/FinanceIndex')

export default [
  {
    path: '/finances',
    name: 'finances.index',
    component: FinanceIndex,
    meta: { requiresAuthentication: true }
  }
]
